import React from 'react';

import { Stack } from '@mantine/core';
import { ContextModalProps, closeAllModals } from '@mantine/modals';

import { Team } from 'models';

import { Form } from 'components/forms/Form';
import { FormStatus } from 'components/forms/FormStatus';
import { FormSubmit } from 'components/forms/FormSubmit';
import { TextField } from 'components/forms/fields/TextField';
import { ModalDescription } from 'components/modals/ModalDescription';
import { ModalTitle } from 'components/modals/ModalTitle';
import { RouterService } from 'services/RouterService';
import { TeamService } from 'services/TeamService';
import { UserService } from 'services/UserService';

export type CreateTeamModalProps = {
    message?: React.ReactNode | string;
};

const CreateTeamModal = ({ innerProps }: ContextModalProps<CreateTeamModalProps>) => {
    const { message } = innerProps || {};

    return (
        <>
            <Form<Pick<Team, 'name'>>
                onSubmit={async ({ name }, { setSubmitError }) => {
                    const result = await TeamService.create(name);

                    if (!result?.doc) {
                        setSubmitError('Something went wrong creating your team. Please try again.');
                        return;
                    }

                    await UserService.switchTeam(result.doc.id);

                    closeAllModals();
                    RouterService.reload();
                }}
            >
                <Stack gap="xs">
                    <ModalTitle>Create new team</ModalTitle>
                    {message && <ModalDescription ta="center">{message}</ModalDescription>}

                    <TextField name="name" placeholder="Enter team name" required />
                    <FormStatus />
                    <FormSubmit disableIfClean>Create new team</FormSubmit>
                </Stack>
            </Form>
        </>
    );
};

export { CreateTeamModal };
